<cm-full-page-feedback class="cm-full-page-feedback" [icon]="$provider() ?? 'google'" text="Verifying SSO login"></cm-full-page-feedback>
